import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpEventType } from '@angular/common/http';
import { AppConfig } from 'src/app/app.config';
import { Observable, Subject } from 'rxjs';
import { ApiResponse } from 'src/app/main/_models/api-response';

@Injectable({
	providedIn: 'root'
})
export class UploadService {

	constructor(
		private http: HttpClient,
		private config: AppConfig) { }

	public getDownloadLink(uploadConfig: UploadConfig): string {
		return `${this.config.getConfig("apiEndpoint")}/download/` + uploadConfig.uploadType + `/` + uploadConfig.id;
	}

	public upload(files: Set<File>, uploadConfig: UploadConfig): { [key: string]: Observable<number> } {

		const status = {};

		files.forEach(file => {

			const formData: FormData = new FormData();
			formData.append('file', file, file.name);
			formData.append("id", uploadConfig.id + "");
			formData.append("type", uploadConfig.uploadType);
			formData.append("originalFilename", uploadConfig.originalFilename);
			formData.append("contentType", uploadConfig.contentType);

			const req = new HttpRequest('POST', this.config.getConfig("apiEndpoint") + "/upload", formData, {
				reportProgress: true
			});

			const progress = new Subject<number>();

			this.http.request(req).subscribe(event => {

				console.log(event);
				if (event.type === HttpEventType.UploadProgress) {

					// calculate the progress percentage
					const percentDone = Math.round(100 * event.loaded / event.total);

					// pass the percentage into the progress-stream
					progress.next(percentDone);
				} else if (event.type === HttpEventType.ResponseHeader) {

					if (event.status == 200)
						progress.complete();
					else
						progress.error("");
				}
			},
				error => {
					progress.error(error);
				}
			);

			// Save every progress-observable in a map of all observables
			status[file.name] = {
				progress: progress.asObservable()
			};
		});

		// return the map of progress.observables
		return status;
	}

	delete(uploadConfig: UploadConfig): Observable<ApiResponse> {
		return this.http.delete<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/upload/` + uploadConfig.uploadType + `/` + uploadConfig.id);
	}

	get(uploadConfig: UploadConfig): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/upload/` + uploadConfig.uploadType + `/` + uploadConfig.id);
	}

	download(uploadConfig: UploadConfig): Observable<Blob> {
		return this.http.get<Blob>(`${this.config.getConfig("apiEndpoint")}/download/` + uploadConfig.uploadType + `/` + uploadConfig.id, { responseType: "blob" as "json" });
	}

}

export interface UploadConfig {

	id: number;
	uploadType: string; //L: logo, CV: Condizioni di vendita, PP: Privacy Policy, CS: Condizioni di servizio, DP: foto autista, DL: patente autista
	originalFilename: string;
	contentType: string;
	isNew: boolean;

}